<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'" :closable="false">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.license_dialog_title')}}</h2>
        </div>
        <span class="">
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="container-accept-license p-4 ml-2 overflow-y-auto dark:text-darkblue-200 vld-parent" @scroll="onScroll">
        <LicenseContent style="max-height: 55vh"/>
      </div>
    </template>
    <template slot="footer">
      <div class="flex space-x-2 px-2 bg-white py-1 mt-auto dark:bg-darkblue-900 justify-between w-full items-center">
        <base-button-responsive @click="logout" mode="secondary-phantom-blue" icon="logout" :text="$t('app.cancel')"/>
        <div class="flex">
          <base-button @click="downloadLicense" mode="secondary-phantom-blue" :text="$t('app.download')" class="mr-2"/>
          <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.accept_license')"/>
          <a href="/files/EdasInvoiZE-Licencia-uso.pdf" download class="hidden" ref="downloadLicense"/>
        </div>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import BaseDialogButton from '../base/BaseDialogButton.vue'
import LicenseContent from './LicenseContent.vue'
import { updateLicense } from '@/services/configurations/licenseUser/updateLicense'

export default
{
  name: 'license-dialog',
  components: {
    BaseDialogButton,
    LicenseContent,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      licenseReaded: false,
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    // TODO
    this.isLoadedData = true
  },
  computed: {
  },
  methods: {
    toggleDialog: async function () {
      if (this.licenseReaded) {
        try {
          const response = await updateLicense()
          if (response.blnError === true) {
            console.err(`${response.msgError} [${response.codError}]`)
          } else {
            this.isOpen = !this.isOpen
            this.$emit('toggleDialog')
          }
        } catch (error) {
          this.doFeedback()
          console.error(error)
        }
      } else {
        this.doFeedback(i18n.t('feedback.info.read_license_msg'), 'info')
      }
    },
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.licenseReaded = true
      }
    },
    downloadLicense () {
      this.$refs.downloadLicense.click()
    },
    logout () {
      this.licenseReaded= false
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.$store.dispatch('auth/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.container-accept-license {
  height: 100%;
}
</style>
